"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchLoupeIcon16Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.SearchLoupeIcon16Solid = forwardRef_1.forwardRef('SearchLoupeIcon16Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 .3a6.7 6.7 0 1 0 3.978 12.092l2.317 2.317a1 1 0 0 0 1.414-1.414l-2.317-2.317A6.7 6.7 0 0 0 8 .3ZM3.3 7a4.7 4.7 0 1 1 9.4 0 4.7 4.7 0 0 1-9.4 0Z" })));
});
